import React from 'react';

const FrontPage = ({ isActiveWomensMode }) => {
    const bgImage = isActiveWomensMode
        ? '/img/page/backgrounds/Fondo-SelfieFan-Femenil.jpeg'
        : '/img/page/backgrounds/Fondo-SelfieFan-Varonil.jpeg';

    return (
        <>
            <div className='FrontPage--Riddle__Screen__Background'>
                <img
                    src={bgImage}
                    alt="Fondo Pantalla"
                    className='FrontPage--Riddle__Screen__Background__Image'
                />
            </div>

            <div className="FrontPage--Riddle__Screen__Container">
                <img
                    src='/img/page/xolos-five.png'
                    alt="Logo"
                    className='FrontPage--Riddle__Screen__Container__Logo'
                />
                <p className="FrontPage--Riddle__Screen__Container__Title">ADIVINA ADIVINADOR</p>
                <img
                    src="/img/games/riddle/female/january-24-2026/provi-logotipo.png"
                    alt="Brand Logo"
                    className="FrontPage--Riddle__Screen__Container__BrandLogo"
                />
            </div>

            <footer className='SelfieFan__Screen__QR__Footer FooterCredits'>Hecho con ♥ por Interaktia | 2026</footer>
        </>
    );
};

export { FrontPage };